import { useState } from "react";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import UpdateAdminImage from "./UpdateAdminImage";
import AdminChangePassword from "./AdminChangePassword";

const TABS = [
  { id: "photo", label: "Change Image" },
  { id: "password", label: "Change Password" },
];

const AdminProfile = () => {
  const [activeTab, setActiveTab] = useState("photo");

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4">
      <HelmetTags title="Profile | Mr.Mohamed Salama" />
      <div className="admin-profile">
        <h2 className="admin-profile__title">Profile</h2>

        <div className="admin-profile__tabs" role="tablist">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`admin-profile__tab ${
                activeTab === tab.id ? "is-active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="admin-profile__tab-panel" role="tabpanel">
          {activeTab === "photo" ? (
            <UpdateAdminImage />
          ) : (
            <AdminChangePassword />
          )}
        </div>
      </div>
    </section>
  );
};

export default AdminProfile;
